<template lang="pug">
section.subpage.profile.pb-5(ref="subpage",v-if="$auth.isAuthenticated && $parent.currentUser")
  h2.title.d-flex
    span {{ page.title }}
    .ml-auto
      b-button(variant="outline-primary",@click="doResetPassword()",:disabled="editable")
        span パスワードのリセット
  ValidationObserver(slim,ref="observer")
    b-form(ref="form",:data-mode="mode",@submit.prevent)
      b-container(fluid)
        b-row
          b-col(cols=6)
            b-form-group(label="氏名",label-for="input-name",description="",required)
              ValidationProvider(rules="required",name="氏名",v-slot="{ errors }")
                b-form-input#input-name(v-model="datum.name",type="text",required,placeholder="氏名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group.email(label="メールアドレス",label-for="input-email",description="")
              ValidationProvider(rules="required",name="メールアドレス",v-slot="{ errors }")
                b-form-input#input-email(:value="datum.email",type="email",placeholder="",@input="validateInput",disabled,readonly)
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="携帯電話番号",label-for="input-mobile",description="")
              ValidationProvider(:rules="{ regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/ }",name="携帯電話番号",v-slot="{ errors }")
                b-form-input#input-mobile(v-model="datum.mobile",type="tel",placeholder="携帯電話番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
        b-row(v-if="datum.role === 'agent' || datum.role === 'consultant'")
          b-col(cols=6)
            b-form-group(label="会社名",label-for="input-company",description="")
              ValidationProvider(rules="",name="会社名",v-slot="{ errors }")
                b-form-input#input-company(v-model="datum.company",type="text",placeholder="会社名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
        b-row
          b-col(cols=6)
            b-form-group(label="部署",label-for="input-department",description="")
              ValidationProvider(rules="",name="部署",v-slot="{ errors }")
                b-form-input#input-department(v-model="datum.department",type="text",placeholder="部署を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="役職",label-for="input-position",description="")
              ValidationProvider(rules="",name="役職",v-slot="{ errors }")
                b-form-input#input-position(v-model="datum.position",type="text",placeholder="役職を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="Slack ID",label-for="input-slackId",description="")
              ValidationProvider(rules="",name="Slack ID",v-slot="{ errors }")
                b-form-input#input-slackId(v-model="datum.slackId",type="text",placeholder="Slack ID を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="チャットワークID",label-for="input-chatworkId",description="")
              ValidationProvider(rules="",name="チャットワークID",v-slot="{ errors }")
                b-form-input#input-chatworkId(v-model="datum.chatworkId",type="text",placeholder="チャットワークIDを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

        b-row.mt-3.mb-2
          b-col.d-flex.justify-content-between
            .form-group.mb-0
              label 予備のメールアドレス
        b-row
          b-col.otherEmails(cols=6)
            b-card.mb-1(no-body,bg-variant="transparent",v-for="(email, index) in datum.otherEmails",:key="index")
              b-card-title.position-absolute
                b-button.removeOtherEmails(variant="link",@click="removeOtherEmails(index)",:disabled="!editable || (datum.otherEmails && datum.otherEmails.length <= 0)")
                  i.menu-icon.fas.fa-minus-circle
              b-card-body.p-0
                b-container(fluid)
                  b-row.mb-1
                    b-col
                      b-form-group.mb-0(label="",:label-for="`input-otherEmail_${index + 1}`",description="",required)
                        ValidationProvider(rules="required|email",:ref="`validate-otherEmail_${index + 1}`",:name="`メールアドレス(${index + 1}行目）`",v-slot="{ errors }")
                          template(v-if="editable")
                            b-form-input.input-otherEmail(:id="`input-otherEmail_${index + 1}`",v-model="email.email",type="email",required,placeholder="メールアドレスを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                          template(v-else)
                            b-input-group
                              b-form-input.input-otherEmail.border-right-0(:id="`input-otherEmail_${index + 1}`",v-model="email.email",type="email",:disabled="!editable",:readonly="!editable")
                              b-input-group-prepend
                                b-input-group-text.py-0.px-3.border-left-0
                                  span.text-success(v-if="!!email.state") 検証済
                                  span.text-danger(v-else) 未検証
                                b-button.py-0.px-3(variant="outline-primary",@click="onSendText(email.email)") テスト

            template(v-if="editable")
              b-button.addOtherEmails(variant="link",@click="addOtherEmails()",:disabled="!editable || (datum.otherEmails && datum.otherEmails.length >= 3)")
                i.align-middle.menu-icon.fas.fa-plus-circle
                span.align-middle.ml-2 メールアドレスを追加
            template(v-else)
              p.pl-2.text-muted(v-if="!datum.otherEmails || datum.otherEmails.length === 0") 未登録

      footer.buttons
        b-button.mr-3(variant="primary",v-show="mode === 'show'",@click="onEdit()")
          span.ml-1 変更する
        b-button.mr-3(variant="outline-primary",v-show="mode === 'edit'",@click="onCancel()")
          span.ml-1 キャンセル
        b-button.mr-3(variant="primary",v-show="mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
          span.ml-1 保存する
</template>

<script>
import { isEqual } from 'lodash'

import { getData, patchData, postData } from '../utils/api'

import { clone, difference } from '../utils/libs'

const page = {
  id: 'profile',
  title: 'プロフィール情報'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      page: page,
      mode: 'show',
      editable: false,
      changed: false,
      valid: false,
      datum: {},
      recentDatum: {},
      sendTo: ''
    }
  },
  watch: {
    $route (to, from) {
      this.changeMode()
    }
  },
  async mounted () {
    this.mode = 'show'
    this.editable = false
    this.changeMode()
  },
  methods: {
    async validateInput () {
      this.valid = await this.$refs.observer.validate()

      if (this.valid) {
        let index = 0
        if (this.datum.otherEmails && this.datum.otherEmails.length > 0) {
          for (let otherEmail of this.datum.otherEmails) {
            if (otherEmail && otherEmail.email) {
              if (otherEmail.email === this.datum.email) {
                this.$refs[`validate-otherEmail_${index + 1}`][0].setErrors(['主メールアドレスと同じメールアドレスは指定できません'])
                this.valid = false
              }
            }
            index++
          }
        }
      }

      if (this.valid) {
        if (this.datum.otherEmails && this.datum.otherEmails.length > 1) {
          for (let i = 0; i < this.datum.otherEmails.length - 1; i++) {
            for (let j = i + 1; j < this.datum.otherEmails.length; j++) {
              if (this.datum.otherEmails[i].email === this.datum.otherEmails[j].email) {
                // this.$refs[`validate-otherEmail_${i + 1}`][0].setErrors(['同じメールアドレスを指定することはできません'])
                this.$refs[`validate-otherEmail_${j + 1}`][0].setErrors(['同じメールアドレスを指定することはできません'])
                this.valid = false
              }
            }
          }
        }
      }

      const diffDatum = difference(this.datum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }
      this.recentDatum = clone(this.datum)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      this.loadData()
    },
    async loadData () {
      this.mask = true

      let message = ''

      try {
        await getData(`/myprofile/`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)
          }

          if (!this.datum.otherEmails || !Array.isArray(this.datum.otherEmails) || this.datum.otherEmails.length === 0) {
            this.datum.otherEmails = []
          }
        }).catch((err) => {
          console.log(err)
          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        this.validateInput()

        this.changed = false
        this.valid = false
      } catch (e) {
        message = 'データの読込に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }

      this.$parent.$refs.header.checkCondition()

      this.$forceUpdate()
    },
    onEdit () {
      this.loadData()
      this.editable = true
      this.mode = 'edit'
    },
    onCancel () {
      this.loadData()
      this.editable = false
      this.mode = 'show'
    },
    onChange (elm) {
      // debugger
    },
    onChangePassword () {
    },
    addOtherEmails () {
      this.datum.otherEmails.push({
        email: ''
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeOtherEmails (index) {
      this.datum.otherEmails.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    async onSave () {
      await this.validateInput()
      this.valid = await this.$refs.observer.validate()

      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('プロフィール情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)

      datum.otherEmails = []
      if (this.datum.otherEmails && this.datum.otherEmails.length > 0) {
        this.datum.otherEmails.forEach((otherEmail) => {
          if (otherEmail && otherEmail.email) {
            datum.otherEmails.push({ email: otherEmail.email })
          }
        })
      }

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      delete datum.email

      delete datum._id

      if (datum.role === 'admin' || datum.role === 'master' || datum.role === 'manager' || datum.role === 'recruiter' || datum.role === 'staff') {
        delete datum.company
      }

      // let userId = null

      let message = null

      try {
        await patchData(`/myprofile/`, datum).then((json) => {
          // userId = json._id
          this.loadData()
          this.editable = false
          // this.editable = true
          this.mode = 'show'
          // this.mode = 'edit'
        }).catch((err) => {
          console.log(err)
          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        console.log(e)
        message = 'データの保存に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    },
    async onSendText (email) {
      this.sendTo = email
      this.msgBoxConfirm('テストメールを送信しますか？', this.doSendText)
    },
    async doSendText () {
      this.mask = true

      let message = null

      try {
        await postData(`/myprofile/test/`, {
          to: this.sendTo
        }).then((json) => {
          // userId = json._id
          this.loadData()
          this.editable = false
          // this.editable = true
          this.mode = 'show'
          // this.mode = 'edit'
        }).catch((err) => {
          console.log(err)
          message = 'テストメールの送信に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        console.log(e)
        message = 'テストメールの送信に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.msgBoxError(
          this.$createElement('div', {
            domProps: {
              innerHTML: `テストメールを送信しました<br>本文中の確認用URLをクリックしてください。`
            }
          })
        )
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.form-group.email >>> label::after
  content ''
#input-email
  // background-color transparent
  // border-bottom 1px solid #aaa

.otherEmails
  .card
    .card-title
      width 100%
      display flex
      justify-content flex-end
      margin-top 0
      // z-index 1001
    .card-body
      // z-index 1000
      input:not([readonly="readonly"])
        width calc(100% - 2.25rem)

.addOtherEmails
.removeOtherEmails
  z-index 1000
  i
    font-size 1.5rem
.addOtherEmails
  padding 0.5rem 1rem 1.5rem 1rem
  i
    color #156eff
.removeOtherEmails
  padding 0.75rem 0.25rem 0 0
  i
    color #999
  &.disabled
    display none

</style>
